import { SignatoryCard } from "./KycViewOwnership";

function safeArr(v) {
  return Array.isArray(v) ? v : [];
}

export default function KycViewSignatories({ sectionNo = 0, form }) {
  const o = form?.ownership || {};
  const signatories = safeArr(o.controllers).length
    ? safeArr(o.controllers)
    : safeArr(o.signatories);

  return (
    <div className="card kycCard">
      <div className={"kycSectionHead kycSectionHeadSection" + sectionNo}>
        <h3 className="kycSectionTitle">
          {sectionNo ? `${sectionNo} | ` : ""}Authorised Signatories
        </h3>
      </div>

      <div className="kycSectionBody">
        <div className="d-grid" style={{ gap: 14 }}>
          {signatories.length ? (
            signatories.map((item, idx) => (
              <SignatoryCard
                key={item?._rowId || item?.name || idx}
                item={{ ...item, _allSignatories: signatories }}
              />
            ))
          ) : (
            <div className="kycInfoViewText" style={{ color: "#9aa5b0" }}>—</div>
          )}
        </div>
      </div>
    </div>
  );
}
